"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RcrtEventRef = exports.RcrtEventTeam = exports.RcrtEventScout = exports.RcrtEvent = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class RcrtEvent extends model_core_1.Base {
    title = '';
    description = '';
    location = '';
    start = null;
    end = null;
    links = [];
    sport = index_1.ERcrtSports.NONE;
    gender = null;
    image = null;
    state = '';
    city = '';
    tz = '';
    errors = [];
    errorCount = 0;
    counts = { scouts: 0, teams: 0, games: 0, schools: 0 };
    user = null;
    teams = new model_core_1.ChildArray();
    scouts = new model_core_1.ChildArray();
    _m = ['title', 'image'];
    _s = ['active', 'title', 'image', 'counts', 'description', 'location', 'gender', 'sport', 'errorCount', 'links', 'start', 'end'];
    get dates() {
        let r = '';
        if (this.start) {
            let sY = (0, model_core_1.formatDate)(this.start, 'yyyy');
            let sM = (0, model_core_1.formatDate)(this.start, 'MMMM');
            if (this.end) {
                let eY = (0, model_core_1.formatDate)(this.end, 'yyyy');
                let eM = (0, model_core_1.formatDate)(this.end, 'MMMM');
                if (eY !== sY) {
                    r = `${(0, model_core_1.formatDate)(this.start, 'MMMM d yyyy')} - ${(0, model_core_1.formatDate)(this.end, 'MMMM d yyyy')}`;
                }
                else if (eM !== sM) {
                    r = `${(0, model_core_1.formatDate)(this.start, 'MMMM d')} - ${(0, model_core_1.formatDate)(this.end, 'MMMM d')}, ${sY}`;
                }
                else {
                    r = `${(0, model_core_1.formatDate)(this.start, 'MMMM d')}-${(0, model_core_1.formatDate)(this.end, 'd')}, ${sY}`;
                }
            }
            else {
                r = `${(0, model_core_1.formatDate)(this.start, 'MMMM d')}, ${sY}`;
            }
        }
        return r;
    }
    constructor(data, olMap) {
        super('events', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtEvent);
        index_1.eventLinkTypes.forEach(id => {
            if (!this.getLink(id)) {
                this.add('links', { id: id, url: '', lock: 0, error: index_1.ERcrtScrapingErrors.MISSING_URL });
            }
        });
    }
    getLink(id) {
        return this.links?.find(l => l.id === id);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (!opts.properties) {
            opts.properties = [];
        }
        await super.loadAll(opts, stack, p);
        // Sort teams by title
        if (this.teams?.length) {
            this.teams.sort((a, b) => a.title < b.title ? -1 : 1);
        }
    }
    toJSON() {
        let r = super.toJSON();
        // Proactively set errors to null when there are none so we can query for records with errors (e.g. where('errors','!=',null));
        if (!this.errors?.length) {
            r.errors = null;
        }
        r.errorCount = this.errors?.length || 0;
        return r;
    }
    save(parent) {
        if (!this.id) {
            throw `Cannot save event without id.`;
        }
        this.last_date = Date.now();
        return super.save(parent);
    }
    sharePath() {
        return `/public/ev/${this._docRef.parent.parent.id}/${this.id}`;
    }
}
exports.RcrtEvent = RcrtEvent;
class RcrtEventScout extends model_core_1.Base {
    title = ''; // Place to store school name when we can't resolve it with our college table via search.
    staff = [];
    ref = null;
    college = null;
    _m = ['name'];
    constructor(data, olMap) {
        super('scouts', 14);
        data = (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtEventScout);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (this.ref) {
            this.college = new index_1.College(opts.getDoc ? await opts.getDoc(this.ref) : await this.ref.get(), index_1.olm);
        }
        await super.loadAll(opts, stack, p);
    }
    toJSON() {
        if (this.college?._docRef) {
            this.id = this.college.id;
            this.active = (this.active !== null) ? this.active : true;
            this.last_date = Date.now();
            this.ref = this.college._docRef;
        }
        let r = super.toJSON();
        delete r.college;
        return r;
    }
}
exports.RcrtEventScout = RcrtEventScout;
class RcrtEventTeam extends model_core_1.Base {
    name = '';
    title = '';
    links = [];
    image = null;
    games = [];
    gender = null;
    sport = index_1.ERcrtSports.NONE;
    _m = ['name', 'image'];
    constructor(data, olMap) {
        super('teams', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtEventTeam);
        if (this.title && !this.name) {
            this.name = this.title;
        }
    }
    getLink(id) {
        return this.links?.find(l => l.id === id);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
    }
}
exports.RcrtEventTeam = RcrtEventTeam;
class RcrtEventRef extends model_core_1.Base {
    event_date = null;
    ref = null;
    teamRef = null;
    team = null;
    games = [];
    notes = '';
    event = null;
    linkedTeam = null;
    shares = new model_core_1.ChildArray();
    counts = { colleges: 0, archived: 0, emails: 0, comments: 0, shares: 0 };
    results_views = 0;
    results_card = 0;
    results_pviews = 0;
    results_plays = 0;
    constructor(data, olMap) {
        super('event_refs', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, RcrtEventRef);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (this.ref) {
            this.event = new RcrtEvent(opts.getDoc ? await opts.getDoc(this.ref) : await this.ref.get(), index_1.olm);
        }
        if (this.teamRef) {
            this.linkedTeam = new RcrtEventTeam(opts.getDoc ? await opts.getDoc(this.teamRef) : await this.teamRef.get(), index_1.olm);
        }
        await super.loadAll(opts, stack, p);
    }
    async save(parent, setDoc) {
        if (!this.event?._docRef && !this.ref) {
            throw `Cannot save College reference until it has a docRef!`;
        }
        else {
            this.id = this.id || this.event?.id;
            this.active = (this.active !== null) ? this.active : true;
            this.last_date = this.last_date || Date.now();
            this.ref = this.event?._docRef || this.ref;
        }
        return super.save(parent, setDoc);
    }
    toJSON() {
        if (!this.event?._docRef) {
            throw `Cannot save RcrtEventRef reference until it has a docRef!`;
        }
        else {
            this.id = this.event.id;
            this.active = (this.active !== null) ? this.active : true;
            this.last_date = Date.now();
            this.ref = this.event._docRef;
        }
        if (this.linkedTeam?._docRef) {
            this.teamRef = this.linkedTeam._docRef;
            if (this.linkedTeam?.games?.length) {
                this.games = [];
            }
        }
        let r = super.toJSON();
        if (this.event?.start) {
            this.event_date = this.event.start;
        }
        delete r.event;
        delete r.linkedTeam;
        return r;
    }
}
exports.RcrtEventRef = RcrtEventRef;
index_1.olm.event_refs = (ref, map) => {
    return new RcrtEventRef(ref, map);
};
index_1.olm.events = (ref, map) => {
    return new RcrtEvent(ref, map);
};
index_1.olm.teams = (ref, map) => {
    return new RcrtEventTeam(ref, map);
};
index_1.olm.scouts = (ref, map) => {
    return new RcrtEventScout(ref, map);
};
